// removed by extract-text-webpack-plugin
module.exports = {"order-history-wrapper":"order-history-wrapper__1TLBo","secondary-row":"secondary-row__bu5Is","secondary-row-item":"secondary-row-item__2Fw7X","secondary-row-item--empty":"secondary-row-item--empty__2VkLE","header":"header__2qemB","cols":"cols__2wwhT","main-row":"main-row__2Jysk","arrow-icon":"arrow-icon__3XX1U","columns":"columns__2Wits","no-orders":"no-orders__2qXze","bg-red":"bg-red__1qcHm","product-img-row":"product-img-row__1Fk-x","product-img":"product-img__3mVAb","expand-pos":"expand-pos__1c7bE"};


//////////////////
// WEBPACK FOOTER
// ./styles/dashboard/ordersHistory.scss
// module id = 1164
// module chunks = 68